import { IPagination } from "utils/http-common";
import { CService } from "./class.base.service";

export interface IGetUsersParams{
  [x:string]:any;
  page: number;
  per_page: number;
  embed: {
    profile: boolean | {
      id:boolean;
      name:boolean;
      type: boolean | {
        id: boolean;
        name: boolean;
      }
    }
  }
}

export interface IResponseGetUser{
  data: any;
  pagination: IPagination
}
class UserService extends CService{
  setSetting(params:any){
    return this.api.patch(`/${this.path}/set-setting`,params);
  }
}

const userService = new UserService("users");
export default userService;